// ---------------------------------------------------------------------------
// Awards Renderer
// ---------------------------------------------------------------------------
// Marketing primitive — publishes the editor `Awards` block as a row of
// award cards parsed from the pipe-delimited textarea the Puck editor
// uses ("Name | Year" per line). Rows with no name are dropped; year is
// optional and rendered as plain text when present.

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { text } from "../escape.js";

interface AwardsProps {
  awards?: string;
}

interface AwardItem {
  name: string;
  year: string;
}

function parseAwards(value: unknown): AwardItem[] {
  if (typeof value !== "string") return [];
  return value
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .map((line) => {
      const [namePart, yearPart] = line.split("|");
      return {
        name: (namePart ?? "").trim(),
        year: (yearPart ?? "").trim(),
      };
    })
    .filter((item) => item.name.length > 0);
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as AwardsProps;

  const awards = parseAwards(p.awards);
  if (awards.length === 0) {
    return "<!-- awards missing entries -->";
  }

  const items = awards
    .map((award) => {
      const yearHtml = award.year
        ? `\n        <p class="ease-awards__year">${text(award.year)}</p>`
        : "";
      return `      <li class="ease-awards__item">
        <p class="ease-awards__name">${text(award.name)}</p>${yearHtml}
      </li>`;
    })
    .join("\n");

  return `<section class="ease-section ease-awards">
    <ul class="ease-awards__list" role="list">
${items}
    </ul>
</section>`;
}

registerRenderer("awards", { render });
